<template>
    <div>
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <h5 class="mb-0">
                    Content

                    <b-badge v-if="hasMediaItems" variant="primary" pill>
                        {{ creatorRequest.medias.length }}
                    </b-badge>
                </h5>
            </div>
            <creator-request-upload
                v-if="hasMediaItems"
                @uploadError="onUploadError"
            >
                <b-btn variant="primary" pill>
                    <font-awesome-icon class="mr-1" icon="fa-light fa-plus" />
                    {{ $t("Add") }}
                </b-btn>
            </creator-request-upload>
        </div>

        <b-alert
            :show="!!uploadError"
            variant="danger"
            dismissible
            @dismissed="uploadError = null"
            class="mt-2 mb-0"
        >
            {{ uploadError }}
        </b-alert>

        <div class="p-3 mb-0 border rounded bg-white">
            <div v-if="hasMediaItems">
                <b-list-group>
                    <b-list-group-item
                        :key="media.id"
                        v-for="(media, i) in creatorRequest.medias"
                        class="d-flex align-items-center justify-content-between"
                    >
                        <div>
                            <font-awesome-icon
                                :icon="
                                    media.type === 'video'
                                        ? 'fa-light fa-video'
                                        : 'fa-light fa-image'
                                "
                                class="mr-2"
                            />
                            {{ media.type === "video" ? "Video" : "Photo" }}
                            {{ i + 1 }}
                        </div>
                        <div>
                            <b-btn
                                :href="media.url"
                                target="_blank"
                                variant="primary"
                                pill
                                size="sm"
                                class="mr-1"
                            >
                                <font-awesome-icon
                                    icon="fa-light fa-download"
                                />
                                <span v-if="$screen.md" class="ml-1">
                                    Download
                                </span>
                            </b-btn>
                            <b-btn
                                v-if="!creatorRequest.fulfilledAt"
                                variant="light"
                                @click="removeMedia(media)"
                                pill
                                size="sm"
                            >
                                <font-awesome-icon
                                    icon="fa-light fa-times"
                                />
                                <span v-if="$screen.md" class="ml-1">
                                    Remove
                                </span>
                            </b-btn>
                        </div>
                    </b-list-group-item>
                </b-list-group>

                <b-alert
                    v-if="
                        creatorRequest.fulfilledAt &&
                        creatorRequestConfig?.retentionDays
                    "
                    variant="light"
                    show
                    class="mt-3 small mb-0"
                >
                    <font-awesome-icon icon="fa-duotone fa-info-circle" />
                    {{
                        $t(
                            "Content is available for {days} days after delivery.",
                            { days: creatorRequestConfig.retentionDays }
                        )
                    }}
                </b-alert>
            </div>
            <div v-else class="py-4 text-center text-secondary">
                <div class="text-primary">
                    Complete the request and collect credits
                </div>

                <div class="my-2 branded">
                    <font-awesome-icon icon="fa-light fa-arrow-down" />
                </div>

                <creator-request-upload @uploadError="onUploadError">
                    <b-btn variant="primary" pill size="lg">
                        <font-awesome-icon
                            class="mr-1"
                            icon="fa-light fa-plus"
                        />
                        Add Photo/Video
                    </b-btn>
                </creator-request-upload>

                <div class="mt-3 text-warning small">
                    Make sure to follow instructions carefully
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import { mapState } from "vuex";

import CreatorRequestUpload from "@/components/creator/requests/CreatorRequestUpload";

export default {
    data() {
        return {
            uploadError: null,
        };
    },
    methods: {
        removeMedia(media) {
            this.$store.dispatch("creatorRequest/removeMedia", media.id);
        },
        onUploadError(message) {
            this.uploadError = message;
        },
    },
    computed: {
        hasMediaItems() {
            return this.creatorRequest.medias?.length > 0;
        },
        ...mapState("creatorRequest", [
            "creatorRequest",
            "creatorRequestConfig",
        ]),
    },
    components: {
        CreatorRequestUpload,
    },
};
</script>
